import { Alert } from "antd";
import styled, { css } from "styled-components";
import { theme } from "../../../theme";
import { gray1 } from "../../../theme/antTheme/theme";

const AlertStyled = styled(Alert)<{ inline?: boolean }>`
  &.ant-alert {
    ${({ inline }) =>
      inline &&
      css`
        border: none;
        background: transparent;
        padding: 0;
        & svg {
          fill: inherit;
        }
      `}

    & .ant-alert-content {
      & .ant-alert-message {
        ${theme.typo.body.r14};
        color: ${gray1};
      }
    }
  }
`;

export { AlertStyled };
